module.exports = __webpack_public_path__ + "static/img/file_objective_c.80384d75.png";